import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import About from "./components/Pages/About";
import Appointments from "./components/Pages/Appointments";
import Blog from "./components/Pages/Blog";
import BlogDetails from "./components/Pages/BlogDetails";
import Contact from "./components/Pages/Contact";
import DepartmentDetails from "./components/Pages/DepartmentDetails";
import Departments from "./components/Pages/Departments";
import DoctorDetails from "./components/Pages/DoctorDetails";
import Doctors from "./components/Pages/Doctors";
import ErrorPage from "./components/Pages/ErrorPage";
import Faqs from "./components/Pages/Faqs";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";
import TermsAndConditions from "./components/Pages/TermsAndConditions";
import Gallery from "./components/Pages/Gallery";
import Home from "./components/Pages/Home";
import PatientProfile from "./components/Pages/patientprofile";
import SignIn from "./components/Pages/SignIn";
import SignUp from "./components/Pages/SignUp";
import Timetable from "./components/Pages/Timetable";
import UpdateProfilePage from "./components/Pages/UpdateProfilePage";
import PaymentForm from "./components/PaymentForm";
import MockPaymentGateway from "./components/MockPaymentGateway";
import ConfirmationPage from "./components/ConfirmationPage";
import ForgotPassword from "./components/Pages/ForgotPassword";
import ResetPassword  from "./components/Pages/ResetPassword";

// ✅ Import your new service details page
import ServiceDetails from "./components/Pages/ServiceDetails"; // make sure this path is correct

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="doctors" element={<Doctors />} />
        <Route path="doctors/:doctorId" element={<DoctorDetails />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog-details" element={<BlogDetails />} />
        <Route path="blog-details/:id" element={<BlogDetails />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="departments" element={<Departments />} />
        <Route path="/departments/:dname" element={<DepartmentDetails />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="timetable" element={<Timetable />} />
        <Route path="contact" element={<Contact />} />
        <Route path="signin" element={<SignIn />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="/patientprofile" element={<PatientProfile />} />
        <Route path="/Faqs" element={<Faqs />} />
        <Route path="/Termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/update-profile" element={<UpdateProfilePage />} />
        <Route path="/payment" element={<PaymentForm />} />
        <Route path="/mock-payment" element={<MockPaymentGateway />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />

        {/* ✅ New Route for individual service details */}
        <Route path="/services/:slug" element={<ServiceDetails />} />
        <Route path="about" element={<About />} />
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
